import React from 'react';
import AboutHero from '../../components/AboutHero/AboutHero';
import Principle from '../../components/Principle/Principle';
import Founder from '../../components/Founder/Founder';
import Teams from '../../components/Teams/Teams';
import ChooseUs from '../../components/ChooseUs/ChooseUs';
import Questions from '../../components/Questions/Questions';
import { Helmet } from 'react-helmet-async';

const AboutUs = () => {

    return (
        <>
            <Helmet>
                {/* Title */}
                <title>Trusted Financial Advisors in Australia | About PFGS</title>

                {/* Meta Description */}
                <meta
                    name="description"
                    content="Discover PFGS’s story, values, and experienced financial advisors dedicated to helping Australians achieve wealth, retirement, and investment goals."
                />

                {/* Canonical URL */}
                <link rel="canonical" href="https://pfgs.com.au/about" />

                {/* Meta Robots */}
                <meta
                    name="robots"
                    content="index, follow, max-snippet:-1, max-video-preview:-1, max-image-preview:large"
                />

                {/* Open Graph (Facebook / LinkedIn / WhatsApp) */}
                <meta property="og:title" content="Trusted Financial Advisors in Australia | About PFGS" />
                <meta property="og:description" content="Discover PFGS’s story, values, and experienced financial advisors dedicated to helping Australians achieve wealth, retirement, and investment goals." />
                <meta property="og:url" content="https://pfgs.com.au/about" />
                <meta property="og:type" content="website" />
                <meta property="og:image" content="https://pfgs.com.au/pfgs-preview.jpg" />

                {/* Twitter Cards */}
                <meta name="twitter:card" content="summary_large_image" />
                <meta name="twitter:title" content="Trusted Financial Advisors in Australia | About PFGS" />
                <meta name="twitter:description" content="Discover PFGS’s story, values, and experienced financial advisors dedicated to helping Australians achieve wealth, retirement, and investment goals." />
                <meta name="twitter:image" content="https://pfgs.com.au/pfgs-preview.jpg" />
            </Helmet>
            <div className="about-page">
                <AboutHero />
                <Principle />
                <ChooseUs color="#f5f5f5" />
                <Teams />
                <Founder />
                <Questions />
            </div>
        </>
    );
};

export default AboutUs;
